import { render, staticRenderFns } from "./CarbonDashboard.vue?vue&type=template&id=6a650362&scoped=true&"
import script from "./CarbonDashboard.vue?vue&type=script&lang=js&"
export * from "./CarbonDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CarbonDashboard.vue?vue&type=style&index=0&id=6a650362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a650362",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a650362')) {
      api.createRecord('6a650362', component.options)
    } else {
      api.reload('6a650362', component.options)
    }
    module.hot.accept("./CarbonDashboard.vue?vue&type=template&id=6a650362&scoped=true&", function () {
      api.rerender('6a650362', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/CarbonDashboard.vue"
export default component.exports